import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  DEFAULT_PAYMENT_PROVIDERS,
  EEntityType,
  ERelationType,
} from '@web/dtos';
import { TextInputComponent } from '../../../../../components/data-input/form-inputs/text-input/text-input.component';
import { TranslationAccessibilityTextInputComponent } from '../../../../../components/data-input/form-inputs/translation-accessibility-text-input/translation-accessibility-text-input.component';
import {
  IFooterBlockForm,
  IFooterPaymentProviderForm,
} from '../../../../../entities/footer-entity';
import { PaymentProviderStore } from '../../../../../services/api/payment-provider/payment-provider-store.service';
import { CmsTextProviderService } from '../../../../../services/cms-text-provider.service';

@Component({
  selector: 'aw-footer-payments-block-editor',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TextInputComponent,
    TranslationAccessibilityTextInputComponent,
  ],
  templateUrl: './footer-payments-block-editor.component.html',
})
export class FooterPaymentsBlockEditorComponent {
  readonly block = input.required<FormGroup<IFooterBlockForm>>();
  readonly index = input.required<number>();

  protected readonly cmsTextProvider = inject(CmsTextProviderService);
  protected readonly paymentProviderStore = inject(PaymentProviderStore);
  protected readonly EntityType = EEntityType;
  protected readonly TextRelationType = ERelationType;

  protected paymentProviderName(id: string): string {
    return (
      DEFAULT_PAYMENT_PROVIDERS.find(provider => provider.id === id)
        ?.filename ?? ''
    );
  }

  protected rows(visible: boolean): Array<{
    form: FormGroup<IFooterPaymentProviderForm>;
    index: number;
  }> {
    return this.block()
      .controls.paymentProviders.controls.map((form, index) => ({
        form,
        index,
      }))
      .filter(row => row.form.controls.visible.value === visible);
  }

  protected moveProvider(index: number, direction: -1 | 1): void {
    const rows = this.block().controls.paymentProviders;
    const target = this.moveTarget(index, direction);
    if (target === -1) return;

    const row = rows.at(index);
    rows.removeAt(index, { emitEvent: false });
    rows.insert(target, row, { emitEvent: false });
    rows.updateValueAndValidity();
    this.block().markAsDirty();
  }

  protected moveTarget(index: number, direction: -1 | 1): number {
    const rows = this.block().controls.paymentProviders;
    const visible = rows.at(index).controls.visible.value;
    for (
      let target = index + direction;
      target >= 0 && target < rows.length;
      target += direction
    ) {
      if (rows.at(target).controls.visible.value === visible) return target;
    }
    return -1;
  }

  protected toggleProvider(form: FormGroup<IFooterPaymentProviderForm>): void {
    form.controls.visible.setValue(!form.controls.visible.value);
    this.block().markAsDirty();
  }
}
